<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Propostas</p>
                <b-button @click="showFiltersBar" class="lupabusca">
                  <i class="fas fa-search dp-none"></i>
                </b-button>
                <b-button @click="hideFiltersBar" class="lupabusca closeLupa">
                  <i class="fas fa-times dp-none"></i>
                </b-button>

                <div>
                  <div class id="tabela-propostas">
                    <b-button v-if="cargo == 'admin' || cargo == 'diretor'"
                      class="is-white"
                      tag="router-link"
                      to="proposta/create"
                      type="is-link"
                    >ADICIONAR NOVA PROPOSTA</b-button>

                    <b-table
                      :data="isEmpty ? [] : propostas.data"
                      paginated
                      backend-pagination
                      @page-change="onPageChange"
                      :total="propostas.total"
                      :per-page="propostas.per_page"
                      :hoverable="true"
                      >
                    >
                      <template slot-scope="props">
                        <!-- colunas-->

                        <input type="hidden" :id="props.row.id"/>

                        <b-table-column field="numero" label="Código" searchable>{{ props.row.numero }}</b-table-column>

                        <b-table-column field="nome" label="Título" searchable>{{ props.row.nome }}</b-table-column>

                        <b-table-column field="grade" label="Grade" searchable>{{ props.row.grade }}</b-table-column>

                        <b-table-column v-if="cargo == 'admin'" field="escola" label="Escolas" searchable>
                          <span v-if="! Object.keys(props.row.escolas).length">Aberto</span>
                          <b-select v-else :placeholder="`Escolas disponiveis`" expanded>
                            <option
                              v-for="(nome, id) in props.row.escolas"
                              v-bind:key="id"
                              :value="id"
                            >{{ nome }}</option>
                          </b-select>
                        </b-table-column>

                        <b-table-column field="created_at" label="criada em" searchable>{{ props.row.created_at }}</b-table-column>

                        <b-table-column field="actions" class="actionsHover" centered>
                          <!-- detalhes -->
                          <b-tooltip label="Red" position="is-top" type="is-dark">
                            <a v-bind:href="props.row.url" target="_blank">
                              <button class="button is-primary is-round" id="baixar">
                                <b-icon icon="eye"></b-icon>
                              </button>
                            </a>
                          </b-tooltip>
                          <b-tooltip label="Rep" position="is-top" type="is-dark">
                            <router-link
                              :to="{ name: 'proposta/videoaula', params: { uuid: props.row.id }}"
                            >
                              <button class="button is-primary is-round" id="aula">
                                <b-icon class="icon-videoaulas custom-icon-tabela"></b-icon>
                              </button>
                            </router-link>
                          </b-tooltip>

                          <!-- editar -->
                          <b-tooltip v-if="cargo == 'admin' || cargo == 'diretor'" label="Editar proposta" position="is-top" type="is-dark">
                            <router-link
                              :to="{ name: 'proposta/update', params: { uuid: props.row.id }}"
                            >
                              <button class="button is-primary is-round red">
                                <b-icon icon="pencil"></b-icon>
                              </button>
                            </router-link>
                          </b-tooltip>

                          <!-- deletar -->
                          <b-tooltip v-if="cargo == 'admin' || cargo == 'diretor'" label="Deletar proposta" position="is-top" type="is-dark">
                                  <button
                                    class="button is-primary is-round"
                                    id="delete"
                                    @click="deletarProposta(props.row.id)"
                                  >
                                    <b-icon icon="delete-outline"></b-icon>
                                  </button>
                                </b-tooltip>
                        </b-table-column>
                      </template>
                      <template slot="empty">
                        <Empty :messageEmpty="'Nada aqui.'" />
                      </template>
                      <template slot="loading">
                        <Empty :messageEmpty="'Carregando...'" />
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PropostaService from "@/services/PropostaService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import Empty from "@/components/Tables/Empty";
import store from "@/store";

export default {
  data() {
    return {
      propostas: [],
      proposta: [],
      isEmpty: false,
      loading: true,
      isImageModalActive: false,
      isCardModalActive: false,
      cargo: store.getters.cargo,
      cargoId: store.getters.cargo_id
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    Empty: Empty
  },
  created() {
    this.loading = true;
    this.onPageChange(1);
  },
  updated(){
    if(this.loading){
      this.configSearch();
      this.loading = false;
    }
  },
  methods: {
    onPageChange(page, codigo, titulo, grade) {
       
      PropostaService.Index(this.cargo, this.cargoId, page, codigo, titulo, grade).then(result => {
        result.data = Object.values(result.data)
        this.propostas = result;
      });
    },
    configSearch(){
      this.tableOverrideInputs(
        document.getElementsByClassName("table")[0],
        this.search,
        [0, 1, 2] // Código, Título, Grade
      );
    },
    search(){
    let p = document.getElementsByClassName("table")[0].firstElementChild.lastElementChild.getElementsByTagName('input');
   
      this.onPageChange(1, p[0].value, p[1].value, p[2].value);
    },
    deletarProposta(uuid) {
      this.serviceDelete(
        "Você tem certeza que deseja deletar essa proposta?", 
        "Proposta deletada com sucesso", 
        PropostaService.Delete, 
        uuid,
        this.$buefy.toast,
        document.getElementById(uuid).parentNode
      );
    }
  }
};
</script>